/** 关键位置对应Key（前端使用）*/
export const placeKeysMap = {
    // pageKey
    gift: {
        // sonKey
        desc1: 'desc1'
    },
    skill: {
        table_bottom_desc1: 'table_bottom_desc1',
        talbe_data: 'talbe_data',
    }
};

const NormolRoleIds = [100, 101];
const RoamingRoleIds = [102];
const lyraRoleIds = [1022, 1023, 1024, 1025];

const normalTableData = [
    ['Guide Lv.', 'Skill Lv.'],
    ['1-10', 'Lv.0'],
    ['11-20', 'Lv.1'],
    ['21-30', 'Lv.2'],
    ['31-40', 'Lv.3'],
    ['41-49', 'Lv.4'],
    ['50', 'Lv.5'],
];

const ROLE_CONFIG_MAP = {
    normal: {
        ids: NormolRoleIds,
        options: {
            gift: {
                [placeKeysMap.gift.desc1]:  'h5_guide_gift_content',
            },
            skill: {
                [placeKeysMap.skill.table_bottom_desc1]: 'h5_guide_table_desc',
                [placeKeysMap.skill.talbe_data]: normalTableData,
            }
        },
    },
    roaming: {
        ids: RoamingRoleIds,
        options: {
            gift: {
                [placeKeysMap.gift.desc1]:  'h5_guide_gift_content',
            },
            skill: {
                [placeKeysMap.skill.table_bottom_desc1]: 'h5_guide_table_desc',
                [placeKeysMap.skill.talbe_data]: normalTableData,
            }
        },
    },
    lyra: {
        ids: lyraRoleIds,
        options: {
            gift: {
                [placeKeysMap.gift.desc1]:  'h5_guide_gift_content_hide',
            },
            skill: {
                [placeKeysMap.skill.table_bottom_desc1]: 'h5_guide_table_desc_hide',
                [placeKeysMap.skill.talbe_data]: [],
            }
        },
    },
};

/** 查找当前角色使用的预设国际化key
 * - 参数1 角色id
 * - 参数2 placeKeysMap[page_key][son_key]
*/
export const getTextByRoleIdAndPalce = (roleId, placeKey) => {
    const configKeys = Object.keys(ROLE_CONFIG_MAP);
    let returnKey = '';
    configKeys.forEach(key => {
        const config = ROLE_CONFIG_MAP[key];
        const { ids, options } = config;
        const targetDex = ids?.findIndex(i => i == roleId);
        if(targetDex > -1){
            const optionsKeys = Object.keys(options);
            optionsKeys.forEach(opKey => {
                const curOption = options[opKey];
                const pageKeys = Object.keys(curOption);
                pageKeys.forEach(paKey => {
                    const value = curOption[paKey];
                    if(paKey == placeKey){
                        // console.log("paKey: ", paKey);
                        // console.log("value: ",  value);
                        returnKey = value;
                        return;
                    }
                })
            })
            return;
        }
    })
    return returnKey;
}